module.exports = __webpack_public_path__ + "static/fonts/PhonkRegularDemo.e2eafe4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/PhonkRegularDemo.woff
// module id = 2333
// module chunks = 24